"use client";

import { useState, useEffect, useCallback } from "react";

export function useLogo() {
  const [logoUrl, setLogoUrl] = useState("");
  const [loginBgUrl, setLoginBgUrl] = useState("");

  const load = useCallback(async () => {
    try {
      const res = await fetch("/api/system-settings");
      if (res.ok) {
        const data = await res.json();
        setLogoUrl(data.logoUrl || "");
        setLoginBgUrl(data.loginBgUrl || "");
      }
    } catch { /* */ }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { logoUrl, loginBgUrl };
}
